export default {
  question(params) {
    return Request.get('api/qa/client', params);
  },
};
